<div class="dropdown">
  <div class="dropdown-src">
    <div #content cdkOverlayOrigin #trigger="cdkOverlayOrigin" class="content-wrapper">
      <ng-content></ng-content>
    </div>
    <ng-template
      cdk-connected-overlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isListVisible"
      [cdkConnectedOverlayHasBackdrop]="true"
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      [cdkConnectedOverlayPositions]="overlayPositions"
      (backdropClick)="handleClickOutside()"
      (detach)="handleClickOutside()"
    >
      <ul class="nested-dropdown-panel" [class.on-left]="onLeft" [ngClass]="panelClass">
        <ng-container *ngTemplateOutlet="customDroplist || defaultDropdown"></ng-container>
      </ul>
    </ng-template>
  </div>
</div>
<ng-template #defaultDropdown>
  @for (dropEl of dropData; track dropEl) {
    <li (click)="ul.classList.toggle('block'); handleParentClick(dropEl)">
      @if (!dropEl.translate) {
        <span>{{ dropEl.title }}</span>
      } @else {
        <span>{{ dropEl.title | transloco }}</span>
      }
      <ul #ul [ngClass]="{ 'for-selected': selectedValue, 'on-left': onLeft }" [class]="dropEl.title">
        @for (nestEl of dropEl.nested; track nestEl) {
          <li
            (click)="$event.stopPropagation(); handleNestClick(dropEl.type, nestEl.value)"
            [ngClass]="{ 'selected-item': nestEl?.selected }"
          >
            <span> {{ nestEl.text }}</span>
          </li>
        }
      </ul>
    </li>
  }
</ng-template>
